import _Layout from './Layout';

import './style/index.js';

export type { LayoutProps } from './Layout';
export * from './type';

export const Layout = _Layout;
export default Layout;
